import React from "react";
import CompanyLogo from "./CompanyLogo/CompanyLogo.";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // console.log("LOGO DA EMPRESA", this.props);
    return (
      <div className="row">
        <div className="col-12 mt-1 mb-1">
          <>
            <CompanyLogo logo={this.props.logo} />
          </>
        </div>
      </div>
    );
  }
}

export default Header;
